<template>
  <div class="pop" :style="isOpen ? 'display:block' : 'display:none'">
    <div class="popup-mask"></div>
    <div class="pop-content pop-ani pop-drag" style="width: 970px;">
      <div class="pop-head">
        <h2>PHR Code 수정</h2>
        <button class="btn-x" @click="doClose()"></button>
      </div>
      <div class="pop-body" style="overflow:unset">
        <validation-observer ref="phrCodeUpdateValidate">
          <form>
            <table class="table-style-default table-pop">
              <colgroup>
                <col width="130px" />
                <col width="*" />
              </colgroup>
              <tbody>
                <tr>
                  <th>
                    용어체계
                    <i class="star">*</i>
                  </th>
                  <td>
                    <select
                      class="input-24 w-100 mt-3"
                      v-model="updatePhrCodeInfo.codeSysTyCode"
                      :disabled="updatePhrCodeInfo.isAlreadyPassed"
                      @change="doChangeCodeSysTyCode()"
                    >
                      <option :value="''">-- 용어체계 선택 --</option>
                      <option
                        v-for="(item, index) in phrCodeSysTys"
                        :key="index"
                        :value="item.codeId"
                      >
                        {{ item.codeName }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>
                    리소스 유형
                    <i class="star">*</i>
                  </th>
                  <td>
                    <select
                      class="input-24 w-100 mt-3"
                      v-model="updatePhrCodeInfo.resrceTyCode"
                    >
                      <option :value="''">-- 리소스 유형 선택 --</option>
                      <option
                        v-for="(item, index) in fhirResrceTys"
                        :key="index"
                        :value="item.codeId"
                      >
                        {{ item.codeName }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>
                    Measure Key
                    <i class="star">*</i>
                  </th>
                  <td>
                    <validate-form
                      :label="'Measure Key'"
                      :rules="{ required: true, min: 2, max: 100 }"
                      :input-class="'input-24 w-100'"
                      v-model="updatePhrCodeInfo.mesureKey"
                      :disabled="updatePhrCodeInfo.isAlreadyPassed"
                      @input="doInputMesureKey()"
                    />
                  </td>
                </tr>
                <tr>
                  <th>
                    코드 이름
                    <i class="star">*</i>
                  </th>
                  <td>
                    <validate-form
                      :label="'코드 이름'"
                      :rules="{ required: true, min: 2, max: 20 }"
                      :input-class="'input-24 w-100'"
                      v-model="updatePhrCodeInfo.mesureCodeNm"
                    />
                  </td>
                </tr>
                <tr>
                  <th>
                    코드 설명
                    <i class="star">*</i>
                  </th>
                  <td>
                    <validate-form
                      :label="'코드 설명'"
                      :rules="{ required: true, min: 2, max: 100 }"
                      :input-class="'input-24 w-100'"
                      v-model="updatePhrCodeInfo.mesureCodeDc"
                    />
                  </td>
                </tr>
                <tr>
                  <th>
                    코드 값
                    <i class="star">*</i>
                  </th>
                  <td>
                    <validate-form
                      :label="'코드 값'"
                      :rules="{ required: true, min: 2, max: 100 }"
                      :input-class="'input-24 w-100'"
                      v-model="updatePhrCodeInfo.mesureCode"
                    />
                  </td>
                </tr>
                <tr>
                  <th>
                    자식 코드
                  </th>
                  <td>
                    <table
                      class="table-style-default"
                      style="max-height:200px; overflow: auto;"
                    >
                      <colgroup>
                        <col width="6%" />
                        <col width="22%" />
                        <col width="22%" />
                        <col width="22%" />
                        <col width="22%" />
                        <col width="6%" />
                      </colgroup>
                      <thead>
                        <tr>
                          <th></th>
                          <th>
                            Measure Key
                          </th>
                          <th>
                            코드 이름
                          </th>
                          <th>
                            코드 설명
                          </th>
                          <th>
                            코드 값
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in updatePhrCodeInfo.children"
                          :key="index"
                        >
                          <td>
                            {{ index + 1 }}
                          </td>
                          <td>
                            <input
                              class="input-24"
                              :class="item.isAlreadyPassed ? 'w-100' : ''"
                              :style="
                                item.isAlreadyPassed ? '' : 'width: 102px'
                              "
                              v-model="item.mesureKey"
                              :disabled="item.isAlreadyPassed"
                              @input="doInputChildrenMesureKey(index)"
                            />
                            <button
                              type="button"
                              class="bt-line24"
                              @click="doGetIsExistMesureKeyFromChildren(index)"
                              v-show="!item.isAlreadyPassed"
                            >
                              확인
                            </button>
                          </td>
                          <td>
                            <input
                              class="input-24"
                              v-model="item.mesureCodeNm"
                            />
                          </td>
                          <td>
                            <input
                              class="input-24"
                              v-model="item.mesureCodeDc"
                            />
                          </td>
                          <td>
                            <input class="input-24" v-model="item.mesureCode" />
                          </td>
                          <td>
                            <input
                              type="button"
                              class="bt-line22"
                              :class="
                                updatePhrCodeInfo.children.length > index + 1
                                  ? 'bt-num-minus'
                                  : 'bt-num-plus'
                              "
                              @click="doManageRow($event, index)"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </validation-observer>
        <p class="pop-btn-group">
          <input
            type="button"
            :value="btnSubmit"
            class="bt-line30 cr-orange"
            @click="doConfirm()"
          />
          <input
            type="button"
            :value="btnCancel"
            class="bt-line30 cr-default"
            @click="doClose()"
          />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ValidateForm from '@/components/ValidateForm.vue';

export default {
  props: {
    isOpen: {
      required: true,
      type: Boolean,
      default: false,
    },
    phrCodeSysTys: {
      required: true,
      type: Array,
    },
    fhirResrceTys: {
      required: true,
      type: Array,
    },
    updatePhrCodeInfo: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {};
  },
  components: { ValidateForm },
  methods: {
    doReset() {
      this.$refs.phrCodeUpdateValidate.reset();
    },
    doClose() {
      this.doReset();
      this.$emit('close', false);
    },
    doGetIsExistMesureKey() {},
    doManageRow(e, index) {
      const classList = e.target.classList;
      if (classList.contains('bt-num-plus')) {
        this.$emit('addRow');
      } else {
        this.$emit('deleteRow', index);
      }
    },
    doGetIsExistMesureKeyFromChildren(index) {
      const {
        mesureKey,
        codeSysTyCode,
        children,
        isAlreadyPassed,
        isPassedMesureKey,
      } = this.updatePhrCodeInfo;

      if (!isAlreadyPassed || !isPassedMesureKey) {
        this.$dialogs.alert('잘못된 접근입니다.');
        return false;
      }

      const childMesureKey = children[index].mesureKey;
      if (!childMesureKey) {
        this.$dialogs.alert(
          `자식 코드 ${index + 1}의 Measure Key를 입력해주세요.`,
        );
        return false;
      }

      if (mesureKey === childMesureKey) {
        this.$dialogs.alert('Measure Key는 Unique 값입니다.');
        return false;
      }

      const reqObj = {
        codeSysTyCode,
        mesureKey: childMesureKey,
      };

      this.$emit('getIsExistChildrenMesureKey', index, reqObj);
    },
    doInputMesureKey() {
      this.$emit('inputMesureKey', 'parents', null);
    },
    doInputChildrenMesureKey(index) {
      this.$emit('inputMesureKey', 'child', index);
    },
    doChangeCodeSysTyCode() {
      this.$emit('changeCodeSysTyCode');
    },
    async doConfirm() {
      const result = await this.$refs.phrCodeUpdateValidate.validate();
      if (!result) {
        this.$dialogs.alert(this.$i18n.t('common.alert.required'));
        return false;
      }

      const {
        isAlreadyPassed,
        isPassedMesureKey,
        resrceTyCode,
        children,
      } = this.updatePhrCodeInfo;
      if (!isAlreadyPassed || !isPassedMesureKey) {
        this.$dialogs.alert('잘못된 접근입니다.');
        return false;
      }

      if (!resrceTyCode) {
        this.$dialogs.alert('리소스 유형을 선택해주세요.');
        return false;
      }

      let isHasChildren = false;
      if (children.length > 0) {
        const {
          mesureKey: firstMesureKey,
          mesureCodeNm: firstMesureCodeNm,
          mesureCodeDc: firstMesureCodeDc,
          mesureCode: firstMesureCode,
        } = children[0];

        if (
          children.length !== 1 ||
          firstMesureKey ||
          firstMesureCodeNm ||
          firstMesureCodeDc ||
          firstMesureCode
        ) {
          isHasChildren = true;
        } else {
          isHasChildren = false;
        }
      }

      if (isHasChildren) {
        let isPassedChildren = true;
        let childFailIdx;

        for (let i in children) {
          let child = children[i];
          const {
            mesureKey,
            mesureCodeNm,
            mesureCodeDc,
            mesureCode,
            isPassedMesureKey,
          } = child;

          if (
            !mesureKey ||
            !mesureCodeNm ||
            !mesureCodeDc ||
            !mesureCode ||
            !isPassedMesureKey
          ) {
            isPassedChildren = false;
            childFailIdx = Number(i);
            break;
          }
        }

        if (!isPassedChildren) {
          this.$dialogs.alert(`자식 코드 ${childFailIdx + 1}를 확인해주세요.`);
          return false;
        }
      }

      this.$emit('updatePhrCode', isHasChildren);
    },
  },
  computed: {
    btnSubmit() {
      return this.$i18n.t('common.btn.submit');
    },
    btnCancel() {
      return this.$i18n.t('common.btn.cancel');
    },
  },
};
</script>

<style scoped>
.pop-body {
  max-height: 100%;
}
.table-style-default {
  text-align: center;
}

.table-style-default > thead > tr > th {
  text-align: center;
}

.bt-line22 {
  min-width: 0px;
}
</style>
